import _         from 'lodash';
import pluralize from 'pluralize';
import Immutable from 'immutable';

import Backend  from 'alto-utils/lib/backend';

import Repository      from './repository';
import RelationBuilder from './relation_builder';

import { BelongsTo, HasMany, HasManyThrough, AssociationCollection } from './associations';

export default class RepositoryBuilder {
  constructor() {
    this.relations    = new Immutable.Map;
    this.associations = new AssociationCollection;
  }

  // this is used in
  // - old tests
  // - {canteen,kredit,bakare}/app/{settings,auth}
  // - alto-react-canteen/lib/models/{menu,menu_with_orders}
  for(baseUrl, auth) {
    return this.forBackend(new Backend(baseUrl, auth));
  }

  forBackend(backend) {
    const repository = new Repository(backend, this);

    this.relations.forEach(function(relation) {
      Object.defineProperty(repository, relation.name, {
        get() { return relation.for(this); }
      });
    });

    return repository;
  }

  registerRelation(model, route = null, name = null) {
    if (name == null) { name = _.lowerFirst(pluralize(model.name)); }

    this.relations = this.relations.set(name, new RelationBuilder(name, model, route));
  }

  registerHasMany(hasManyModel, belongsToModel, name = null, foreignKey = null, backendName = null) {
    if (name        == null) { name        = _.lowerFirst(pluralize(belongsToModel.name)); }
    if (foreignKey  == null) { foreignKey  = _.lowerFirst(hasManyModel.name) + 'ID';       }
    if (backendName == null) { backendName = _.snakeCase(name);                            }

    const hasMany = new HasMany(name, backendName, hasManyModel, belongsToModel, foreignKey);

    this.associations = this.associations.add(hasMany);
  }

  registerBelongsTo(belongsToModel, hasManyModel, name = null, foreignKey = null, backendName = null) {
    if (name        == null) { name        = _.lowerFirst(hasManyModel.name); }
    if (backendName == null) { backendName = _.snakeCase(name);               }
    if (foreignKey  == null) { foreignKey  = name + 'ID';                     }

    const belongsTo = new BelongsTo(name, backendName, belongsToModel, hasManyModel, foreignKey);

    this.associations = this.associations.add(belongsTo);
  }

  registerHasManyThrough(sourceModel, name, associationNames) {
    if (associationNames.length < 2) {
      throw new Error('HasManyThrough association needs at least two association names');
    }

    this.associations = this.associations.add(new HasManyThrough(name, sourceModel, associationNames));
  }

  // TODO: add registerHasOne
  // TODO: add registerHasOneThrough

  registerAllFrom(repository) {
    this.registerRelationsFrom(   repository);
    this.registerAssociationsFrom(repository);
  }

  registerRelationsFrom(repository) {
    this.relations = repository.relations.merge(this.relations);
  }

  registerAssociationsFrom(repository) {
    this.associations = repository.associations.merge(this.associations);
  }
}
